module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "alert"
    }
  }, [(_vm.$store.state.error.options.type) ? _c('v-snackbar', {
    staticClass: "ma-2",
    attrs: {
      "top": "",
      "light": "",
      "timeout": 4000,
      "elevation": "1",
      "content-class": "px-0 py-1",
      "color": _vm.$store.state.error.options.type === 'success' ?
        'backgroundGreen' :
        _vm.$store.state.error.options.type === 'error' ?
        'errorRed' :
        'transparent',
      "app": ""
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "small": "",
            "icon": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.closeAlert()
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v("mdi-close")])], 1)]
      }
    }], null, false, 26012812),
    model: {
      value: (_vm.$store.state.error.popAlert),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.error, "popAlert", $$v)
      },
      expression: "$store.state.error.popAlert"
    }
  }, [_c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "fluid": "",
      "three-line": "",
      "color": "transparent"
    }
  }, [_c('v-layout', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-0 py-1 px-2",
    attrs: {
      "shrink": ""
    }
  }, [_c('v-layout', {
    staticClass: "mr-1",
    attrs: {
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0"
  }, [(
    _vm.$store.state.error.options.type ===
    'success'
  ) ? _c('svg', {
    attrs: {
      "width": "4",
      "height": "36",
      "viewBox": "0 0 4 36",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2V34C4 35.1046 3.10457 36 2 36C0.895431 36 0 35.1046 0 34V2Z",
      "fill": "#27AE60"
    }
  })]) : _vm._e(), _vm._v(" "), (
    _vm.$store.state.error.options.type ===
    'error'
  ) ? _c('svg', {
    attrs: {
      "width": "4",
      "height": "36",
      "viewBox": "0 0 4 36",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2V34C4 35.1046 3.10457 36 2 36C0.895431 36 0 35.1046 0 34V2Z",
      "fill": "#DF6767"
    }
  })]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-0 py-1",
    attrs: {
      "shrink": ""
    }
  }, [_c('v-layout', {
    staticClass: "mr-3",
    attrs: {
      "align-center": "",
      "fill-height": ""
    }
  }, [(
    _vm.$store.state.error.options.type ===
    'success'
  ) ? _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('v-icon', {
    attrs: {
      "color": "darkGreen"
    }
  }, [_vm._v("mdi-check-circle")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.$store.state.error.options.type === 'error'
  ) ? _c('v-flex', {
    staticClass: "pa-0"
  }, [_c('v-icon', {
    attrs: {
      "color": "redLight"
    }
  }, [_vm._v("mdi-close-circle")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-1 py-1"
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "roboto-text roboto-500",
    staticStyle: {
      "font-size": "14px",
      "color": "#333333"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$store.state.error.options.message) + "\n                        ")]), _vm._v(" "), (
    !_vm.$store.state.error.isOffline &&
    _vm.$store.state.error.options.submessage
  ) ? _c('v-flex', {
    staticClass: "roboto-text font-weight-400",
    staticStyle: {
      "font-size": "12px",
      "color": "#666666"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', [_vm._v("\n                                    " + _vm._s(_vm.$store.state.error.options
    .submessage) + "\n                                ")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f73a354","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/layout/Alert.vue
// module id = 868
// module chunks = 1